import { render, staticRenderFns } from "./InfrastructureUpgradeCompact.vue?vue&type=template&id=1bfd81d5&scoped=true&"
import script from "./InfrastructureUpgradeCompact.vue?vue&type=script&lang=js&"
export * from "./InfrastructureUpgradeCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd81d5",
  null
  
)

export default component.exports